module.exports = __webpack_public_path__ + "components/flag/static/square/za-07fadbf88850b94ee2435d4895ed88b9.svg";